import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


import { DocCheckboxMultiComponent } from './form-elements/checkbox-multi/checkbox-multi.component';
import { DocCheckboxComponent } from './form-elements/checkbox/checkbox.component';
import { DocDateTimePickerComponent } from './form-elements/date-time-picker/date-time-picker.component';
import { DocFieldErrorComponent } from './form-elements/field-error/field-error.component';
import { DocFileUploaderComponent } from './form-elements/file-uploader/file-uploader.component';
import { DocFileUploaderComponentDialog } from 'src/app/shared/form-elements/file-uploader-dialog/file-uploader-dialog.component';
import { DocInputComponent } from './form-elements/input/input.component';
import { DocRadioComponent } from './form-elements/radio/radio.component';
import { DocSelectComponent } from './form-elements/select/select.component';
import { DocTextareaComponent } from './form-elements/textarea/textarea.component';
import { MaterialComponentsModule } from './material/material.module';
import { DocConsTreatmentIconPipe } from './pipes/cons-treatment-icon.pipe';
import { DocConsTreatmentNamePipe } from './pipes/cons-treatment-name.pipe';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { DocNamePipe } from './pipes/name.pipe';
import { DocPrettySecPipe } from './pipes/sec-time-formater.pipe';
import { DocTimeRangePipe } from './pipes/timerange.pipe';

import { DocNoDataComponent } from './components/no-data/no-data.component';
import { DocRadioInputComponent } from './form-elements/radio-input/radio-input.component';
import { NgxDatePipe } from './pipes/ngx-date.pipe';
import { CustomEditorComponent } from './components/custom-editor/custom-editor.component';
/* import {NgxFilesizeModule} from 'ngx-filesize'; */

@NgModule({
  declarations: [
    DocSelectComponent,
    DocInputComponent,
    DocDateTimePickerComponent,
    DocCheckboxComponent,
    DocFieldErrorComponent,
    DocNamePipe,
    DocTimeRangePipe,
   
    DocTextareaComponent,
    DocFileUploaderComponent,
    DocRadioComponent,
    DocCheckboxMultiComponent,
    DocFileUploaderComponentDialog,
    DocFileUploaderComponent,
  
    DocPrettySecPipe,
   
   
    DocNoDataComponent,
    DocRadioInputComponent,
    NgxDatePipe,
    CustomEditorComponent,
   
    // DocConsTreatmentNamePipe,
    // DocConsTreatmentIconPipe,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MaterialComponentsModule,
    RouterModule,
    NgbRatingModule,
  /*   NgxFilesizeModule */
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialComponentsModule,
    CommonModule,
    DocSelectComponent,
    DocInputComponent,
    DocDateTimePickerComponent,
    DocCheckboxComponent,
    DocFieldErrorComponent,
    RouterModule,
    DocNamePipe,
    DocTimeRangePipe,
   
    DocTextareaComponent,
    DocPrettySecPipe,
    // DocConsTreatmentNamePipe,
    // DocConsTreatmentIconPipe,
    DocRadioComponent,
    DocCheckboxMultiComponent,
    DocFileUploaderComponentDialog,
    DocFileUploaderComponent,
    
    NgbRatingModule,
   
    
    DocNoDataComponent,
    DocRadioInputComponent,
    NgxDatePipe,
 /*    NgxFilesizeModule, */
    
  ],
  providers: [NgxDatePipe, DatePipe],
})
export class SharedModule { }
